import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {},
  filterdata: {},
  surchargeSelection: { otherFees: false, screening: false },
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },

    setFilterData: (state, action) => {
      state.filterdata = action.payload;
    },

    setSurchargeSelection: (state, action) => {
      state.surchargeSelection = action.payload;
    },

    clearFilters: (state) => {
      state.filters = {};
      state.filterdata = {};
      // surchargeSelection is intentionally NOT reset here so it persists when
      // the user comes back from the booking page (the listing remounts and calls
      // clearFilters via getALLFlightRateSearch, which must not wipe the selection).
    },

    clearSurchargeSelection: (state) => {
      state.surchargeSelection = { otherFees: false, screening: false };
    },
  },
});

export const { setFilters, clearFilters, setFilterData, setSurchargeSelection, clearSurchargeSelection } =
  filterSlice.actions;

export default filterSlice.reducer;
